/* eslint-disable import/prefer-default-export */
export var NON_DIGITS_REGEX = /\D/g;